import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import {
  VehicleGroup,
  vehicleGroupSchema,
} from '../schemas/vehicle-group.schema';
import { fleetMessageSchema } from '../schemas/fleet-message.schema';
import { z } from 'zod/v4';
import { fromFetch } from 'rxjs/fetch';

/**
 * Creates an array of new Vehicle Groups
 * @param vehicleGroups The Vehicle Groups being created
 * @param assignAllDefaults Whether to assign all default values to the Vehicle Groups
 * @returns Data object containing the newly created Vehicle Groups
 */
export function postVehicleGroups(
  this: unknown,
  vehicleGroups: Partial<VehicleGroup>[],
  assignAllDefaults: boolean
) {
  let url = fleetEnvironment.resolve(this).vehicleGroupsUrl;
  if (assignAllDefaults) {
    url += '?assignAllDefaults=true';
  }
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(url, {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify(vehicleGroups),
      })
    )
  ).pipe(
    selectData(
      fleetMessageSchema.extend({
        data: z.array(vehicleGroupSchema),
      })
    )
  );
}
